import { AuthState } from "../interfaces/auth"
import { Types } from "../types"
import { AuthTypesActions } from "../types/Auth/actionTypes"





const initialState: AuthState = {
    setNewPasswordPending: false,
    setNewPasswordSuccess: false,
    setNewPasswordError: null
}


const authReducer = (state = initialState, action: AuthTypesActions) => {

    switch (action.type) {
        case Types.SET_NEW_PASSWORD_REQUEST:
            return {
                ...state,
                setNewPasswordPending: true,
                setNewPasswordSuccess: false,
                setNewPasswordError: null
            }
        case Types.SET_NEW_PASSWORD_SUCCESS:

            return {
                ...state,
                setNewPasswordPending: false,
                setNewPasswordSuccess: true,
                setNewPasswordError: null
            }

        case Types.SET_NEW_PASSWORD_ERROR:

            return {
                ...state,
                setNewPasswordPending: false,
                setNewPasswordSuccess: false,
                setNewPasswordError: action.payload
            }

        case Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_REQUEST:
            return {
                ...state,
                checkExistEmailByCustomerIdPending: true,
                checkExistEmailByCustomerIdSuccess: false,
                checkExistEmailByCustomerIdError: null,
                checkExistEmailByCustomerIdResponse: null
            }
        case Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_SUCCESS:

            return {
                ...state,
                checkExistEmailByCustomerIdPending: false,
                checkExistEmailByCustomerIdSuccess: true,
                checkExistEmailByCustomerIdResponse: action.response
            }

        case Types.CHECK_EXIST_EMAIL_BY_CUSTOMER_ID_ERROR:

            return {
                ...state,
                checkExistEmailByCustomerIdPending: false,
                checkExistEmailByCustomerIdSuccess: false,
                checkExistEmailByCustomerIdError: action.payload
            }


        default:
            return {
                ...state
            }
    }
}

export default authReducer